import { render, staticRenderFns } from "./OvTelepulesItem.vue?vue&type=template&id=7aca5951"
import script from "./OvTelepulesItem.vue?vue&type=script&lang=js"
export * from "./OvTelepulesItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports